import { render, staticRenderFns } from "./userRatings.vue?vue&type=template&id=02452c5b&scoped=true&"
import script from "./userRatings.vue?vue&type=script&lang=ts&"
export * from "./userRatings.vue?vue&type=script&lang=ts&"
import style0 from "./userRatings.vue?vue&type=style&index=0&id=02452c5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02452c5b",
  null
  
)

export default component.exports